import type { LocalDateTime } from "@js-joda/core";
import React from "react";
import { useDateTimeFormatContext } from "src/app/hooks/useDateTimeFormatContext";

export interface IFormattedLocalDateTimeProps {
  value: LocalDateTime;
}

export default ({ value }: IFormattedLocalDateTimeProps) => {
  const { dateTimeFormatter } = useDateTimeFormatContext();
  return <>{value.format(dateTimeFormatter)}</>;
};
